module.exports = __webpack_public_path__ + "img/saldo-icon.890598d0.svg";